module.exports = __webpack_public_path__ + "img/FuturaStd-Bold.d0741683.svg";